document.addEventListener('alpine:init', () => {
  Alpine.data('ProductSiblings', () => ({
    $product: null,
    sections: [],
    init() {
      this.InitSelf();
    },
    InitSelf() {
      this.$product = this.$el.closest('#main');
      this.sections = [...this.$product.querySelectorAll('.shopify-section')].map(section => section.id);
      document.body.classList.add('product-loaded');
      this.CheckSwiper();
      setTimeout(this.CheckSwiper.bind(this), 500);
      window.addEventListener('resize', this.CheckSwiper.bind(this));
    },
    async e_LoadProduct() {
      const handle = event.currentTarget.getAttribute('data-handle');
      const template = event.currentTarget.getAttribute('data-template');
      let url = ` /products/${handle}`;
      if (template && template != 'product') {
        url += `?view=${template}`;
      }
      // console.log(url);
      let res = await fetch(url).then(res => res.text());
      // console.log(res);
      this.RenderPage(res);
      history.pushState({}, '', `/products/${handle}`);
    },
    RenderPage(res) {
      let $res = new DOMParser().parseFromString(res, 'text/html');
      document.querySelector('#main').outerHTML = $res.querySelector('#main').outerHTML;
    },
    e_SwiperNext(e) {
      let $swiper = e.target.closest('.swiper');
      const swiper = $swiper.swiper;
      if (!swiper) return;
      swiper.slideNext();
    },
    e_SwiperPrevious(e) {
      let $swiper = e.target.closest('.swiper');
      const swiper = $swiper.swiper;
      if (!swiper) return;
      swiper.slidePrev();
    },
    CheckSwiper() {
      let is_desktop = window.matchMedia("(min-width: 600px)").matches;
      let has_4_items = this.$el.querySelectorAll('.swiper-slide').length > 3;
      let has_5_items = this.$el.querySelectorAll('.swiper-slide').length > 4;
      let $swiper = this.$el.querySelector('.swiper');
      if (!$swiper || !$swiper.swiper) return;

      let swiper = $swiper.swiper;
      if (is_desktop && !has_5_items) {
        swiper.destroy();
      }
      if (!is_desktop && !has_4_items) {
        swiper.destroy();
      }
    }
  }));

  Alpine.data('ProductForm', () => ({
    product: {},
    init() {
      this.InitSelf();
      this.InitWatchers();
    },
    InitSelf() {
      this.product = JSON.parse(this.$el.dataset.product);
      this.$productSection = this.$el.closest('.productAside');
      this.$addToCart = this.$el.querySelector('.productAside__actions button[type="submit"]');
      this.$price = this.$productSection.querySelector('.productPrice');
      this.$stickyBar = document.querySelector('.sticky-addtocart-bar');
      this.$stickyBarBtn = this.$stickyBar.querySelector('button.productAside__atc');
      setTimeout(this.UpdatePrice.bind(this), 250);
    },
    InitWatchers() {
      this.$el.addEventListener('change', (e) => {
        setTimeout(this.UpdatePrice.bind(this), 250);
      });

      // watch intersection observer for add to cart
      let is_mobile = window.matchMedia("(max-width: 767px)").matches;      
      let observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          // is not intersecting and scroll position is beyond top of add to cart
          let scrollY = window.scrollY || window.pageYOffset;
          let addToCartTop = this.$addToCart.getBoundingClientRect().top + scrollY;
          let flag_visible;
          if (is_mobile) {
            flag_visible = scrollY > addToCartTop && !entry.isIntersecting;
          }
          else {
            flag_visible = !entry.isIntersecting;
          }
          this.$stickyBar.classList.toggle('visible', flag_visible)
        });
      }, { threshold: [0] });
      
      observer.observe(this.$addToCart);

      // add to cart
      this.$stickyBarBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.$addToCart.click();
      });
        
    },
    UpdatePrice() {
      this.$stickyBar.querySelector('.productPrice').innerHTML = this.$price.innerHTML;
    }
  }));

  Alpine.data('StickyAddToCartBar', () => ({
    flags: {
      visible: false,
    },
    init() {
      this.InitWatchers();
      this.InitSelf();
    },
    InitSelf() {
    },
    InitWatchers() {
      document.body.addEventListener('sticky-bar-update-price', (e) => {
        console.log(e);
        let $priceContainer = this.$el.querySelector('.productPrice');
        if ($priceContainer) {
          $priceContainer.innerHTML = e.detail.price;
        }
      });
    }
  }));
});